import { computed, reactive } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const theme = computed(() => store.state.theme);
    const viewKey = computed(() => store.getters.routerViewKey);
    const themeVarsDark = reactive({
      // 这里是 dark 主题的变量
    });
    const themeVarsLight = reactive({
      // 这里是 light 主题的变量
      // primaryBackground: "#FF9800",
      // primaryColor: "#FF9800",
      // successColor: "#00C853",
      // successBackground: "#00C853",
      // buttonDefaultBorderColor: "#ebedf0",
    });
    return {
      theme,
      themeVarsDark,
      themeVarsLight,
      viewKey
    };
  }
};